import React, { useEffect } from 'react';

const Dialog = ({
  className,
  onBlur,
  escKeyFunction,
  children,
  isModalOpen = false,
  ariaLive = false
}) => {
  useEffect(() => {
    function keyListener(e) {
      if (e.keyCode === 27) {
        e.preventDefault();
        escKeyFunction();
      }
    }
    document.addEventListener('keydown', keyListener);
    return () => document.removeEventListener('keydown', keyListener);
  });

  return (
    <div
      className={className}
      onBlur={onBlur}
      role="dialog"
      aria-labelledby="dialogTitleHeading"
      aria-modal={isModalOpen ? true : false}
      {...(ariaLive ? { 'aria-live': 'polite' } : {})}
    >
      {children}
    </div>
  );
};

export default Dialog;
